<script setup>
/**
 * 公告详情弹窗，逐条对齐旧版 web/10.735e88e52b03ea923563.js 里的
 * app-notice 组件（类在模块 "Smx/"，模板工厂 + 样式在模块 ZTCA：工厂 m + 子模板 r、样式 a）。
 *
 * 旧版类：
 *   构造：modal  = navParams.get('modal')
 *         notice = navParams.get('notice')
 *         notice 存在时：noticeContent = _sanitizer.bypassSecurityTrustHtml(notice.notice_content)
 *   dismiss(): modal.dismiss()
 *
 * 旧版打开方式是 modal，不是路由页：
 *   首页 showNotice(notice) →
 *     modalCtrl.create({ component: app-notice, componentProps: { notice } }).present()
 *   （chunk 34 的 tabs 路由表里虽然有一条 {path:"notice/:id"}，
 *     但首页从来没有跳过去，那是一条没有入口的死路由。）
 *
 * 模板：
 *   ion-header > ion-toolbar
 *     ion-buttons[slot=start] > ion-button (click)="dismiss()" > ion-icon[name=arrow-back]
 *     ion-title「 公告 」
 *   *ngIf="notice" →
 *     ion-content[padding]
 *       h4.notice-title      {{ notice.notice_title }}
 *       article.notice-content [innerHTML]="noticeContent"
 *
 * 样式 a（就两条）：
 *   .notice-title{text-align:center;font-size:1rem}
 *   .notice-content{font-size:.8rem}
 *
 * 关于 v-html：旧版明确调了 bypassSecurityTrustHtml，也就是把公告内容当受信 HTML
 * 直接渲染（内容由后台管理员在 admin 里填写）。这里用 v-html 是对齐这个行为，
 * 信任边界跟旧版一致 —— 前提是后台账号可信。
 */
const props = defineProps({
  // 旧版 navParams.get('notice')，字段用到 notice_title / notice_content
  notice: { type: Object, default: null },
})
const emit = defineEmits(['close'])
</script>

<template>
  <div class="notice-modal">
    <!-- 旧版 ion-header > ion-toolbar：arrow-back + 标题「 公告 」 -->
    <header class="modal-header">
      <button class="modal-back" type="button" aria-label="返回" @click="emit('close')">
        <svg class="modal-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor" /></svg>
      </button>
      <h1 class="modal-title"> 公告 </h1>
      <span class="modal-spacer" aria-hidden="true"></span>
    </header>

    <!-- 旧版 r：*ngIf="notice" 包住整个 ion-content[padding] -->
    <div v-if="notice" class="modal-content">
      <h4 class="notice-title">{{ notice.notice_title }}</h4>
      <!-- 旧版 <article class="notice-content" [innerHTML]="noticeContent"> -->
      <article class="notice-content" v-html="notice.notice_content"></article>
    </div>
  </div>
</template>

<style scoped>
/* 弹窗外壳与顶栏跟其它旧版还原弹窗一致，顶栏色取旧版主题变量 #f95454 */
.notice-modal{position:fixed;z-index:30;top:0;left:0;width:100%;height:100%;background:#fff;color:#000;display:flex;flex-direction:column;font:14px Arial,"Microsoft YaHei",sans-serif}
.modal-header{display:flex;align-items:center;height:56px;background:var(--legacy-theme,#f95454);color:var(--legacy-toolbar-color,#fff);position:relative;z-index:1;box-shadow:0 2px 4px rgb(0 0 0 / 20%)}
.modal-back{display:flex;align-items:center;justify-content:center;width:56px;height:56px;border:0;background:transparent;line-height:1;color:inherit;cursor:pointer;padding:0}
.modal-back .modal-icon{width:24px;height:24px;display:block}
.modal-title{flex:1;margin:0;font-size:18px;font-weight:500;text-align:center;color:inherit}
.modal-spacer{width:56px;flex:none}
/* ion-content[padding] → 四边 var(--ion-padding, 16px) */
.modal-content{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px}

/* --- 以下逐条照抄旧版样式表 a（chunk 10 的模块 ZTCA） --- */
.notice-title{text-align:center;font-size:1rem}
.notice-content{font-size:.8rem}

/* 公告正文是后台填的富文本，这里只保证图片不溢出、段落可换行；
   旧版没写这两条，但旧版 Ionic 的全局 styles.css 里带 img{max-width:100%} 类的 reset。 */
.notice-content :deep(img){max-width:100%;height:auto}
.notice-content{word-break:break-word}
</style>
